import React from 'react';
import { Box, Chip, useTheme } from '@mui/material';
import { PERIODS } from '../../utils/accounting/periodUtils';
import { fontSize, fontWeight } from '../../utils/accounting/styles';

const PeriodSelector = ({ value = 'THIS_MONTH', onChange }) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
      {PERIODS.map((p) => (
        <Chip
          key={p.key}
          label={p.label}
          size="small"
          onClick={() => onChange(p.key)}
          variant={value === p.key ? 'filled' : 'outlined'}
          color={value === p.key ? 'primary' : 'default'}
          sx={{
            fontSize: fontSize.xs,
            fontWeight: value === p.key ? fontWeight.semibold : fontWeight.normal,
            borderRadius: '16px',
            height: 28,
            ...(value === p.key && { bgcolor: theme.palette.primary.main, color: theme.palette.primary.contrastText }),
          }}
        />
      ))}
    </Box>
  );
};

export default PeriodSelector;
